<template>
  <div class="success-message" data-test-id="success-message">
    <div v-if="message" class="success-message-overlay" data-test-id="success-message-overlay">
      <div class="success-message-modal" data-test-id="success-message-modal">
        <div class="success-message-top-row">
          <div class="success-header" data-test-id="success-message-header">{{ header }}</div>
        </div>

        <div class="success-message-container">
          <div class="success-body" data-test-id="success-message-message">{{ message }}</div>
        </div>

        <div v-if="hasConfirm" class="success-message-close">
          <button :class="successCss" class="gray-button" @click="confirmSuccess" data-test-id="success-message-confirm">Confirm</button>
          <button :class="successCss" class="default-button" @click="cancelSuccess" data-test-id="success-message-cancel">Cancel</button>
        </div>
        <div v-else class="success-message-close">
          <button :class="successCss" class="default-button" @click="confirmSuccess" data-test-id="success-message-confirm">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSuccessStore } from "@/stores/success_store"
import { computed, ref } from "vue"

const successStore = useSuccessStore()
let header = ref(successStore.getHeader)
let message = ref(successStore.getMessage)
let successLevel = ref(successStore.getSuccessLevel)
let hasConfirm = ref(successStore.getConfirmation)

const successCss = computed(() => {
  return 'bak-' + successLevel.value + '-3'
})

successStore.$subscribe(updateSuccessMessage, { detached: false })
function updateSuccessMessage() {
  header.value = successStore.getHeader
  message.value = successStore.getMessage
  successLevel.value = successStore.getSuccessLevel
  hasConfirm.value = successStore.getConfirmation
}

function cancelSuccess() {
  successStore.cancelSuccess()
}
function confirmSuccess() {
  successStore.confirmSuccess()
}

</script>

<style scoped lang="scss">
@import "./src/assets/main.scss";
.success-message-overlay {
  position: fixed; /* Positioning and size */
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(128,128,128,0.5); /* color */
}
.success-message-modal {
  position: fixed;
  display: block;
  height: 240px;
  width: 600px;
  top: 50vh;
  left: 50%;
  transform: translate(-50%,-50%);
  border: 4px solid $mediumGray1;
  border-radius: 6px;
  background: white;
}
.success-message-top-row {
  background-color: $mediumGray1;
  border-top-left-radius: 3px; // works with 4px border to affect an 8px radius
  border-top-right-radius: 3px;
  height: 36px;
  padding: 5px 20px 0 20px;
}
.success-header {
  text-align: center;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: bold;
  font-size: 18px;
}
.success-body {
  position: absolute;
  top: 60px;
  left: 40px;
  width: calc(100% - 100px);
  height: 148px;
  font-size: 16px;
  overflow: hidden;
}
.success-message-clear {
  position: absolute;
  right: 4px;
  top: 4px;
}
.success-message-close {
  position: absolute;
  right: 4px;
  bottom: 4px;
}
</style>
